import React from 'react';
import Axios from 'axios';
import moment from 'moment';

const cstTableHeaders = [
	'Date', 'Sous-saison', 'Programme', 'Équipe A', 'Équipe B', 'Rondes A', 'Rondes B', 'Points A', 'Points B'];

const cstDefaultSortOrder = [
	'asc', 'asc', 'asc', 'asc', 'asc', 'desc', 'desc', 'desc', 'desc'];

const cstDefaultSortFieldIdx = 0;	// Date


class MatchsPlayed extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			scoresheetsTable: [],
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
			loading: true
		};

		this.loadScoresheetsTable = this.loadScoresheetsTable.bind(this);
		this.createDataTable = this.createDataTable.bind(this);
		this.sortdataTable = this.sortdataTable.bind(this);
		this.displayModule = this.displayModule.bind(this);
		this.displayData = this.displayData.bind(this);
		this.createTableHdrRow = this.createTableHdrRow.bind(this);
		this.createEmptyDataRow = this.createEmptyDataRow.bind(this);
		this.createDataRow = this.createDataRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
	}

	componentDidMount() {
		this.loadScoresheetsTable(this.props.season._id);
	}

  loadScoresheetsTable(seasonId) {
    var _this = this;
    if (seasonId !== "0") {
      //Axios.get('/api/scoresheets/compiled/seasonId/' + seasonId).then(function(response) {
      Axios.get('/api/scoresheets2/compiled/seasonId/' + seasonId).then(function(response) {
				
				console.log('Matchs Played: scoresheets');
				console.log(response.data);

      	_this.createDataTable(response.data);
      });
    }
  }

	createDataTable(dataResults) {
		var _this = this;
		var dataTable = [];

		// Parse results
		dataResults.forEach(function(result, resultIdx) {

			var dataTableRow = [];
			var team1Name = result.team1Name;
			var team2Name = result.team2Name;

			// Individual leagues have some differences

			// dataTableRow.push(0);		// rank
			dataTableRow.push(moment(result.date).utc().format("YYYY-MM-DD"));
			dataTableRow.push(result.subSeason.name);

			// Program / week
			dataTableRow.push(result.week + ((result.ssType === 2) ? " •" : ""));

			if (_this.props.season.formatTeamIndiv === "INDIV") {
				dataTableRow.push(result.team1firstPlayerName);		// Joueur A
				dataTableRow.push(result.team2firstPlayerName);		// Joueur B
				dataTableRow.push(result.team1TotalWins);					// Victoires A
				dataTableRow.push(result.team2TotalWins);					// Victoires B
				dataTableRow.push(result.team1TotalPts);					// Points A
				dataTableRow.push(result.team2TotalPts);					// Points B

			} else {
				dataTableRow.push(team1Name);
				dataTableRow.push(team2Name);

				// Exception: do not show rounds in BARAQUE-500
				if (!_this.props.season.stateloLeagueParam.includes('BARAQUE-500')) {
					if (_this.props.season.formatMatchType === "POINTS ONLY") {
						dataTableRow.push(result.team1TotalWins);						
					} else {
						dataTableRow.push(result.team1TotalRoundPts);
					}
				}

				// Exception: do not show rounds in BARAQUE-500
				if (!_this.props.season.stateloLeagueParam.includes('BARAQUE-500')) {
					if (_this.props.season.formatMatchType === "POINTS ONLY") {
						dataTableRow.push(result.team2TotalWins);						
					} else {
						dataTableRow.push(result.team2TotalRoundPts);
					}
				}

				dataTableRow.push(result.team1TotalPts);
				dataTableRow.push(result.team2TotalPts);
			}

			// Build table
			dataTable.push(dataTableRow.slice());
		});

		// First data sort
		var sortFieldIdx = this.state.sortFieldIdx;
		var sortOrder = this.state.sortOrder;

		_this.sortdataTable(dataTable, sortFieldIdx, sortOrder);
	}

	sortdataTable(dataTable, sortFieldIdx, sortOrder) {

		// Manage empty data
		if (dataTable.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			dataTable.sort(function(a, b) {

				var valueA = a[sortFieldIdx];
				var valueB = b[sortFieldIdx];
				var compVal = 0;

				switch(typeof a[sortFieldIdx]) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
						compVal = valueA.localeCompare(valueB);
		        break;
			    case "number":
						compVal = valueA - valueB;
		        break;
			    default:
		        break;
				}

				if (compVal !== 0) {
					return (sortSign * compVal);
				} else {

					compVal = new Date(b[1]) - new Date(a[1]);
					if (compVal !== 0) {
						return compVal;
					} else {
						return (new Date(a[0]) - new Date(b[0]));
					}
				}
			});
		}

		this.setState({
			dataTable: dataTable,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
			loading: false
		});
	}

	render() {
		// console.log('Scoresheet List: RENDER');
		return (
			<div className="minPageHeight">
				<div className="row">
				<div className="col-md-12">
					<h4>Liste des Matchs joués</h4>
				</div>
				</div>
				<hr className="no-print"/>

				{this.state.loading ? 
					this.displaySpinner() :
					this.displayModule()}
			</div>
		);
	}

	displayModule() {
		if (this.state.loading) {
			return ( this.displaySpinner() );
		} else {
			return ( this.displayData() );
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	displayData() {
		// console.log('ScoresheetsList displayData', this.state.dataTable.length);
		return (
			<div className="table-responsive tableFixHeader resizeVerticalPlayedMatches">
			<table className="table table-striped table-hover table-sm small">

			<thead>
				<tr>
				{cstTableHeaders.map(this.createTableHdrRow)}
				</tr>
			</thead>

			<tbody>
				{(this.state.dataTable.length !== 0)
					? this.state.dataTable.map(this.createDataRow) 
					:	this.createEmptyDataRow()
				}
			</tbody>
			</table>
			</div>
		);
	}

	createTableHdrRow(hdrItem, hdrIdx) {
		// ID Visible only in master mode
		var classNameStr = '';
		var onClickAction = function() {};

		// Individual leagues, display first player in faked team
		if (this.props.season.formatTeamIndiv === "INDIV") {
			if (hdrItem === 'Équipe A') {
				hdrItem = 'Joueur A';
			}
			if (hdrItem === 'Équipe B') {
				hdrItem = 'Joueur B';
			}
		}
		if (this.props.season.formatMatchType === "POINTS ONLY") {
			if (hdrItem === 'Rondes A') {
				hdrItem = 'Victoires A';
			}
			if (hdrItem === 'Rondes B') {
				hdrItem = 'Victoires B';
			}		
		}

		if ((this.props.season.stateloLeagueParam.includes('BARAQUE-500')) && 
			  ((hdrItem === 'Rondes A') || (hdrItem === 'Rondes B'))) {
			return;
		}

		// Sort with arrows
		onClickAction = this.handleSortTable;
		classNameStr = 'statelo-sorting';
		if(hdrIdx === this.state.sortFieldIdx) {
			if (this.state.sortOrder === "asc") {
				classNameStr += ' statelo-sorting_asc';
			} else {
				classNameStr += ' statelo-sorting_desc';
			}
		}

		return (
			<th key={"colid." + hdrIdx}
				id={"colid." + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}

  createEmptyDataRow() {
		return (
			<tr key={'te.0'}>
				<td colSpan="99">Aucun match joué</td>
	    </tr>
    );
  }

  createDataRow(dataRow, dataRowIdx) {
		return (
			<tr key={'te.' + dataRowIdx}>
				{dataRow.map(this.createDataCell)}
      </tr>
    );
  }

 	createDataCell(dataCell, dataCellIdx) {
		return (
			<td key={"tdcell." + dataCellIdx}>{dataCell}</td>
		);
	}

	handleSortTable(e) {
		var _this = this;
		var sortFieldIdx = parseInt(e.target.id.split(".")[1], 10);

		var dataTable = this.state.dataTable;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.sortdataTable(dataTable, sortFieldIdx, sortOrder);
	}

	displaySpinner() {
		return (
  		<div className="row col-md-2">
  		<div className="sk-three-bounce sk-three-bounce-left-align">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  		</div>
  	);
	}
	
}

export default MatchsPlayed;


